import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Permite reactivar una licencia vencida cuando no hayan pasado más de ")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("b", null, "2 meses", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" desde su vencimiento. ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", { class: "font-semibold mt-4" }, "Requisitos", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("ul", { class: "list-disc pl-6 mt-2" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Presentar el cuadro de áreas en el que se identifique lo ejecutado durante la licencia vencida."),
  /*#__PURE__*/_createElementVNode("li", null, "Manifestar bajo la gravedad de juramento que el inmueble se encuentra en alguna de las siguientes situaciones:"),
  /*#__PURE__*/_createElementVNode("ul", { class: "list-decimal pl-8 mt-1" }, [
    /*#__PURE__*/_createElementVNode("li", null, "En licencias de urbanización o parcelación: las obras de urbanización o parcelación están ejecutadas al menos en un 50%."),
    /*#__PURE__*/_createElementVNode("li", null, "En licencias de construcción por unidades independientes estructuralmente: por lo menos la mitad de las unidades cuentan con al menos el 50% de avance estructural."),
    /*#__PURE__*/_createElementVNode("li", null, "En licencias de construcción de una edificación independiente estructuralmente: se ha construido por lo menos el 50% de la estructura portante o del elemento que soporte las cargas."),
    /*#__PURE__*/_createElementVNode("li", null, "En licencias de intervención u ocupación del espacio público: se ha ejecutado la solicitud dentro del término señalado en el acto administrativo."),
    /*#__PURE__*/_createElementVNode("li", null, "En licencias de urbanización en las que se conceda simultáneamente licencia de construcción en modalidad distinta a la de cerramiento: se debe cumplir con las condiciones establecidas en el numeral 1 y, según el sistema estructural, con lo dispuesto en los numerales 2 o 3.")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, "Radicar la solicitud dentro del término establecido (no más de 2 meses después del vencimiento de la licencia).")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { class: "font-semibold mt-4" }, "Procedimiento", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, [
  /*#__PURE__*/_createTextVNode(" Se resuelve con fundamento en las normas de la licencia inicial, con la misma vigencia y la posibilidad de prorrogarse una sola vez por hasta "),
  /*#__PURE__*/_createElementVNode("b", null, "12 meses"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)

import LicenceItem from "./LicenceItem.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LicenceItem, { title: 'Revalidación' }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7
    ]),
    _: 1
  }))
}
}

})